import { t } from "@lingui/macro";
import {StorageKey} from "../../../../../enums/StorageKey";
import { getColumns } from "./CashSummary";

export default {
    storageKey: StorageKey.report_cash_sales_summary,
    getReportLabel: () => t`Cash Sales Summary`,
    required: [
        'date',
        'number',
        'base_amount',
    ],
    defaulto: [
        'payment_methods',
        'contact_name',
        'description',
    ],
    getColumns,
};
